const _Hub_Name = "reporthub";

const _Invoke_Methods_Names = {
  createReport: "CreateReport",
  updateReport: "UpdateReport",
  deleteReport: "DeleteReport",
  duplicateReport: "DuplicationReport",
  favouriteReport: "FavouriteReport",

  createDashboard: "CreateDashboard",
  updateDashboard: "UpdateDashboard",
  deleteDashboard: "DeleteDashboard",
  restoreDashboard: "RestoreDashboard",
  duplicateDashboard: "DuplicateDashboard",

  // DefaultDashboard
  setDefaultDashboard: "DefaultDashboard",

  // lastviewed reports
  lastViewedReport: "LastViewedReport",

  // export report
  exportReport: "ExportReport",
};

const _OnReceive_Methods_Names = {
  onCreateReport: "CreateReportResponse",
  onUpdateReport: "UpdateReportResponse",
  onDeleteReport: "DeleteReportResponse",
  onDuplicateReport: "DuplicationReportResponse",
  onFavouriteReport: "FavouriteReportResponse",

  onCreateDashboard: "CreateDashboardResponse",
  onUpdateDashboard: "UpdateDashboardResponse",
  onDeleteDashboard: "DeleteDashboardResponse",
  onRestoreDashboard: "RestoreDashboardResponse",
  onDuplicateDashboard: "DuplicationDashboardResponse",

  // DefaultDashboard
  onDefaultDashboard: "DefaultDashboardResponse",
};

const Report_Dashboard_signalr = {
  hubName: _Hub_Name,
  InvokeMethodNames: _Invoke_Methods_Names,
  onReceiveMethodNames: _OnReceive_Methods_Names,
};

export default Report_Dashboard_signalr;
